export function darkenHexColor(hex: string, amount: number): string {
    let col = hex.replace('#', '');
    if (col.length === 3) col = col.split('').map(x => x + x).join('');
    const num = parseInt(col, 16);
    let r = Math.max(0, (num >> 16) - Math.round(255 * amount));
    let g = Math.max(0, ((num >> 8) & 0x00FF) - Math.round(255 * amount));
    let b = Math.max(0, (num & 0x0000FF) - Math.round(255 * amount));
    return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
